module.exports = __webpack_public_path__ + "static/img/xuexiwang.7c6aafc9.jpg";